import type { PollSettings, VotesData } from '../../types';
import { groupVotesById } from './group-votes-by-id';

export function fillData({
  answers,
  data
}: {
  answers: PollSettings['answers'];
  data: VotesData | undefined;
}): VotesData {
  if (!data || !data.votes || data.votes.length === 0) {
    const filledVotes = answers.map(({ id }) => ({
      id,
      count: 0,
      percentage: 0
    }));

    return { total: 0, votes: filledVotes };
  }

  const groupedVotes = groupVotesById(data.votes);

  const filledVotes = answers.map(({ id }) => ({
    id,
    count: groupedVotes[id] ? groupedVotes[id][0].count : 0,
    percentage: groupedVotes[id] ? groupedVotes[id][0].percentage : 0
  }));

  return { total: data.total, votes: filledVotes };
}
